import React from "react";
import SpanSuccess from "./SpanSuccess";
import SpanFailed from "./SpanFailed";

const StatusSpan = ({ status }) => {
  if (status === 1) {
    return <SpanSuccess text="有効" />;
  }
  return <SpanFailed text="無効" />;
};

export default StatusSpan;
